var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"copy",class:_vm.classes},[_c('wysiwyg',{attrs:{"balance-text":_vm.block.balanceText,"unorphan":_vm.block.unorphan,"html":_vm.block.copy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }